import styled from 'styled-components';
import { color, whiteSpace, textAlign, uppercase, margin, width, height, padding, fontWeight } from '@10d/tend-ui-styling';
import { fontSize } from '../styled.js';
import { INTERNAL_TypographyBase } from '../Base.js';

const Root = styled(INTERNAL_TypographyBase) `
  &.tend-ui-typography {
    margin-top: 0px;
    ${fontSize};
    ${color};
    ${whiteSpace};
    ${textAlign};
    ${uppercase};
    ${margin};
    ${width};
    ${height};
    ${padding};
    ${fontWeight};
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
